<template>
  <div class="bd_y" v-if="show_body">
    <div class="top_list">
      <ul class="clearfix">
        <li @click="switch_tab(1)" :class="{on: main_show==1}">
          查看邀请<img src="@a/xsj.png" alt="" />
        </li>
        <li @click="switch_tab(2)" :class="{on: main_show==2}">
          报名好友<img src="@a/xsj.png" alt="" />
        </li>
      </ul>
    </div>
    <div class="main_list" v-show="main_show==1">
      <ul v-if="list.length>0">
        <li class="clearfix cjv" v-for="(item,index) in list">
          <img :src="item.headimgurl" class="xtx" />
          <span class="rank_name">{{item.nickname}}</span>
          <span class="rank_right">
                {{item.create_time}} 查看{{item.state ==1 ? '并报名' : ''}}
            </span>
        </li>
      </ul>
      <div class="empry" v-else>
        <img src="@a/empry.png" alt="" />
        <p>尚未成功邀请，还需努力(*^_^*)</p>
      </div>
    </div>
    <div class="main_list" v-show="main_show==2">
      <ul v-if="list.length>0">
        <li class="clearfix cjv" v-for="(item,index) in list" v-if="item.buy_status == 1">
          <img :src="item.headimgurl" class="xtx" />
          <span class="rank_name">{{item.nickname}}</span>
          <span class="rank_right">
              {{item.create_time}} 报名
            </span>
        </li>
      </ul>
      <div class="empry" v-else>
        <img src="@a/empry.png" alt="" />
        <p>尚未成功邀请，还需努力(*^_^*)</p>
      </div>
    </div>
    <div class="pop_img" v-show="card_show" @click="card_show=false"></div>
  </div>
</template>
<script>
import {
  promotionIdList
} from '@/api/person';
import {
  shareCon
} from "@/utils/wxconfig";

export default {
  data() {
      return {
        show_body: false,
        list: [],
        main_show: 1,
        card_show: false,
        type_obj: {},
      }
    },
    methods: {
      pullData() {
        promotionIdList({
          id: this.$route.query.id
        })
          .then((data) => {
            this.show_body = true;
            this.list = data.list;
            shareCon("index", this);
          })
      },
      backTop() {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      },
      switch_tab(main_show) {
        this.main_show = main_show;
        this.backTop();
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.bd_y {
  margin: 30px;
  border-radius: 8px;
}

.pop_img {
  width: 100%;
  height: 100%;
  z-index: 100001;
  position: fixed;
  top: 0;
  left: 0;
  background: url(../../../assets/popse.png) no-repeat top center;
  background-size: cover;
}

.top_list {
  width: 690px;
  height: 80px;
  background: rgba(235, 80, 50, 1);
  border-radius: 8px 8px 0px 0px;
  margin: 0 auto;
  ul li {
    float: left;
    font-size: 32px;
    color: #E1E1E1;
    width: 50%;
    text-align: center;
    line-height: 80px;
    position: relative;
    img {
      width: 26px;
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -13px;
      display: none;
    }
  }
  .on {
    color: #fff;
    img {
      display: block;
    }
  }
}

.main_list {
  ul li {
    padding: 16px 30px;
    border-bottom: 2px solid #E1E1E1;
    background-color: #fff;
    img {
      width: 64px;
      margin-right: 10px;
      border-radius: 50%;
    }
    span {
      font-size: 26px;
      color: #333;
      vertical-align: middle;
    }
    .rank_right {
      float: right;
      margin-top: 18px;
    }
  }
}

.empry {
  margin-top: 287px;
  text-align: center;
  img {
    width: 180px;
  }
  p {
    margin-top: 30px;
    font-size: 26px;
    color: #999;
  }
  a {
    width: 370px;
    height: 66px;
    background: rgba(235, 80, 50, 1);
    border-radius: 33px;
    display: inline-block;
    font-size: 34px;
    color: #fff;
    line-height: 66px;
    margin-top: 50px;
  }
}
</style>
